import { use } from "react";
import clsx from "clsx";

import { getConfig } from "lib/get-config";
import { ModalsContext } from "lib/modals/use-modals";
import { NavigationContext } from "lib/navigation/use-navigation";

import ChevronLeftIcon from "assets/icons/chevron-left.svg?react";
import ChevronRightIcon from "assets/icons/chevron-right.svg?react";
import css from "./stepper.module.scss";

export function Stepper() {
  const { nextPage, prevPage, page, totalPages, isNavigationEnabled } =
    use(NavigationContext)!;
  const { upsell, showUpsell } = use(ModalsContext)!;
  const { trials } = getConfig();

  const atLastPage = page === totalPages - 1;
  const canShowUpsell = atLastPage && !upsell.hasBeenShown && trials !== 1;

  function handleNextClick() {
    if (canShowUpsell) {
      showUpsell();
    } else {
      nextPage();
    }
  }

  return (
    <>
      <button
        className={clsx(css.button, css.prev)}
        onClick={prevPage}
        disabled={page === 0 || !isNavigationEnabled}
        data-testid="flipBack"
      >
        <ChevronLeftIcon width={24} height={24} />
      </button>
      <button
        className={clsx(css.button, css.next)}
        onClick={handleNextClick}
        disabled={(atLastPage && !canShowUpsell) || !isNavigationEnabled}
        data-testid="flipForward"
      >
        <ChevronRightIcon width={24} height={24} />
      </button>
    </>
  );
}
